import { d as _ } from "./keys-CQjWNUL0.mjs";
var R = {}, u = {}, i;
function S() {
  return i || (i = 1, function(e) {
    var n = _;
    n(e, "__esModule", {
      value: !0
    }), e.canUseLocalStorage = c;
    function c() {
      try {
        const t = window.localStorage, r = "__storage_test__";
        return t.setItem(r, r), t.removeItem(r), !0;
      } catch {
        return !1;
      }
    }
  }(u)), u;
}
(function(e) {
  var n = _;
  n(e, "__esModule", {
    value: !0
  }), e.createLogger = g, e.default = void 0;
  var c = S();
  const t = (0, c.canUseLocalStorage)(), r = "color: white; margin: 5px 0; padding: 6px 0; width: 100%;", L = `${r} background-color: #e89600;`, f = `${r} background-color: #e00000;`;
  function v() {
    return t && window.localStorage.getItem("BHR_DEV_LOGGER") === "true";
  }
  function s(o, a, w, d, ...l) {
    v() && (d !== null && (l = [d, ...l]), console[o](a, w, ...l));
  }
  function g(o) {
    return o = o ? `[${o}]` : null, {
      warn(...a) {
        s("warn", "%c BHR DEVELOPMENT WARNING ", L, o, ...a);
      },
      error(...a) {
        s("error", "%c BHR DEVELOPMENT ERROR ", f, o, ...a);
      }
    };
  }
  e.default = g();
})(R);
export {
  R as d
};
//# sourceMappingURL=index-DspsydPg.mjs.map
